import { Grid } from "@mui/material";
import React, {
  useCallback,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { FormProvider, useForm } from "react-hook-form";
import FormAutoComplete from "../../../../Controllers/AutoComplete";
import FormTextField from "../../../../Controllers/Input";
import service from "../../Helpers/gifservices";
import { useLoading } from "../../../../providers/loadingProvider";

const AddRefereeForm = forwardRef(({ submit }, ref) => {
  const methods = useForm();
  const loading = useLoading();

  const [titlesOptions, setTitlesOptions] = useState([]);
  const [institutionOptions, setInstitutionOptions] = useState([]);
  const [countriesOptions, setCountriesOptions] = useState([]);

  const fillTitlesOptions = useCallback(async () => {
    const loadingId = loading.addLoading("loading titles");
    var titlesOptions = await service.GetContactTitles();
    setTitlesOptions(titlesOptions.map((t) => ({ ...t, id: t.value })));
    loading.removeLoading(loadingId);
  }, [loading]);

  const fillInstitutionsOptions = useCallback(async () => {
    const loadingId = loading.addLoading("loading institutions");
    var institutions = await service.getAllInstitutions(false);
    setInstitutionOptions(
      institutions.map((i) => ({ ...i, id: i.institutionId, label: i.name }))
    );
    loading.removeLoading(loadingId);
  }, [loading]);
  const fillCountriesOptions = useCallback(async () => {
    const loadingId = loading.addLoading("loading countries");
    var countries = await service.getAllCountries();
    setCountriesOptions(
      countries.map((c) => ({ ...c, id: c.id, label: c.name }))
    );
    loading.removeLoading(loadingId);
  }, [loading]);
  useEffect(() => {
    fillTitlesOptions();
    fillInstitutionsOptions();
    fillCountriesOptions();
  }, [fillInstitutionsOptions, fillTitlesOptions, fillCountriesOptions]);
  const { handleSubmit } = methods;
  useImperativeHandle(ref, () => ({
    submit() {
      return new Promise((resolve,reject) => {
        handleSubmit((data) => {
          const result = {...data};
          result.institutionName = institutionOptions.find(i => i.id === data.institutionId).label;
          resolve(result);
        })().then(() => resolve(null));
      })
    },
  }));
  const ValidateEmail = (mail) => {
    if (
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        mail
      )
    ) {
      return true;
    }
    return "You have entered an invalid email address";
  };
  return (
    <FormProvider {...methods}>
      <form>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormAutoComplete
              autoFocus={true}
              name="titleCode"
              label="Title"
              options={titlesOptions}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <FormTextField
              autoFocus={true}
              name="firstName"
              label="First Name"
              required
            />
          </Grid>
          <Grid item xs={12}>
            <FormTextField
              autoFocus={true}
              name="lastName"
              label="Last Name"
              required
            />
          </Grid>
          <Grid item xs={12}>
            <FormAutoComplete
              autoFocus={true}
              name="institutionId"
              label="Institution"
              options={institutionOptions}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <FormTextField autoFocus={true} name="websiteurl" label="WebSite" />
          </Grid>
          <Grid item xs={12}>
            <FormTextField
              autoFocus={true}
              name="primaryEmail"
              label="Email"
              validate={ValidateEmail}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <FormAutoComplete
              autoFocus={true}
              name="institutionCountryId"
              label="Country"
              options={countriesOptions}
              required
            />
          </Grid>
        </Grid>
      </form>
    </FormProvider>
  );
});

export default AddRefereeForm;
